<template>
  <div class="layout-wrapper">
    <ConfirmDialog />
    <div :class="['layout-sidebar', { collapsed: isSidebarCollapsed }]">
      <div class="sidebar-logo">
        <img v-if="!isSidebarCollapsed" src="../assets/logo-text.png" srcset="../assets/logo-text.png 1x, ../assets/logo-text@2x.png 2x" alt="logo" class="logo-img" />
        <img v-else src="../assets/logo.png" alt="logo" class="logo-img-collapsed" />
      </div>
      <Menu :model="sidebarItems" class="layout-menu" >
        <template #submenulabel="{ item }">
          <a v-ripple v-tooltip.right="isSidebarCollapsed ? item.label : null" :href="isSidebarCollapsed ? 'javascript:void(0)' : item.url" @click="isSidebarCollapsed ? handleCollapsedMineClick() : subMenuDisplay()" class="p-menuitem-link" :class="{ 'active-menu-item': isMenuItemActive(item) }">
            <img v-if="item.customIcon" :src="getCustomIcon(item)" :alt="item.label" class="custom-icon" />
            <span v-else :class="item.icon" class="p-menuitem-icon" />
            <span v-if="!isSidebarCollapsed" class="p-menuitem-text">{{ item.label }}</span>
            <span v-if="!isSidebarCollapsed && (item.items && item.items.length > 0 || item.label === 'Mine')" :class="['p-submenu-icon', item.label === 'Mine' ? (isMineExpanded ? 'pi pi-angle-up' : 'pi pi-angle-down') : 'pi pi-angle-down']"></span>
          </a>
        </template>
        <template #item="{ item, props }">
          <a v-ripple v-tooltip.right="isSidebarCollapsed ? item.label : null" :href="isSidebarCollapsed ? 'javascript:void(0)' : item.url" @click="isSidebarCollapsed ? handleCollapsedMineClick() : (item.label === 'Mine' && subMenuDisplay())" class="p-menuitem-link" v-bind="item.label === 'Mine' ? {} : props.action" :class="{ 'active-menu-item': isMenuItemActive(item) }">
            <img v-if="item.customIcon" :src="getCustomIcon(item)" :alt="item.label" class="custom-icon" />
            <span v-else :class="item.icon" class="p-menuitem-icon" />
            <span v-if="!isSidebarCollapsed" class="p-menuitem-text">{{ item.label }}</span>
            <span v-if="!isSidebarCollapsed && (item.items && item.items.length > 0 || item.label === 'Mine')" :class="['p-submenu-icon', item.label === 'Mine' ? (isMineExpanded ? 'pi pi-angle-up' : 'pi pi-angle-down') : 'pi pi-angle-down']"></span>
          </a>
        </template>
      </Menu>
      <!-- Debug info -->
      <div v-if="false" style="position: fixed; top: 10px; right: 10px; background: white; padding: 10px; border: 1px solid #ccc; z-index: 9999;">
        <div>Current Route: {{ router.currentRoute.value.path }}</div>
        <div>isMineExpanded: {{ isMineExpanded }}</div>
        <div>mineMenuItem has items: {{ mineMenuItem.value && mineMenuItem.value.items ? 'Yes' : 'No' }}</div>
      </div>
    </div>
    <div class="layout-main">
      <div class="layout-menubar">
        <img :src="isSidebarCollapsed ? iconSidebarExpand : iconSidebarCollapse" alt="toggle sidebar" class="sidebar-toggle-btn" @click="toggleSidebar" />
        <div class="menubar-breadcrumb">
          <template v-for="(bc, idx) in breadcrumbs" :key="bc.path">
            <span v-if="idx !== 0"> / </span>
            <span v-if="idx < breadcrumbs.length - 1">{{ bc.label }}</span>
            <span v-else class="breadcrumb-last">{{ bc.label }}</span>
          </template>
        </div>
        <div class="menubar-actions">
          <div class="bell-wrapper" style="position:relative;">
            <Button icon="pi pi-bell" style="color: gray; border: solid 1px #EBEBEB" class="p-button-text" @click="onBellClick" />
            <span v-if="unreadCount > 0" class="dot-red"></span>
            <NotificationPopover :visible="showNotification" @close="showNotification = false" />
          </div>
          <div class="user-info" @click="toggleUserMenu($event)">
            <img v-if="userStore.userInfo.avatar_url" :src="userStore.userInfo.avatar_url" class="user-avatar" />
            <Avatar v-else icon="pi pi-user" class="user-avatar" size="normal" />
            <div class="user-meta">
              <div class="user-name">{{ userStore.userInfo.nickname }}</div>
              <div class="user-email">{{ userStore.userInfo.email }}</div>
            </div>
          </div>
        </div>
        <Menu ref="userMenu" :model="userMenuItems" :popup="true" class="user-dropdown-menu" />
      </div>
      <div class="layout-content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, onUnmounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import Menu from 'primevue/menu'
import Button from 'primevue/button'
import Avatar from 'primevue/avatar'
import ConfirmDialog from 'primevue/confirmdialog'
import { useConfirm } from "primevue/useconfirm";
import { useUserStore } from '../stores/user'
import iconSidebarExpand from '../assets/icon-sidebar-expand.png'
import iconSidebarCollapse from '../assets/icon-sidebar-collapse.png'
import deviceIcon from '../assets/device.png'
import deviceIconGray from '../assets/device_gray.png'
import workspaceIcon from '../assets/24x24_workspace.png'
import workspaceIconGray from '../assets/24x24_workspace_gray.png'
import taskIcon from '../assets/24x24_task.png'
import taskIconGray from '../assets/24x24_task_gray.png'
import chargerIcon from '../assets/charger.png'
import chargerIconGray from '../assets/charger_gray.png'
import messageIcon from '../assets/message.png'
import messageIconGray from '../assets/message_gray.png'
import myIcon from '../assets/24x24_my.png'
import myIconGray from '../assets/24x24_my_gray.png'
import NotificationPopover from '../components/NotificationPopover.vue'
import { WS_BASE_URL } from '../utils/config'

const router = useRouter()
const route = useRoute()
const userStore = useUserStore()
const userMenu = ref()
const toggleUserMenu = (event) => {
  userMenu.value.toggle(event)
}
const unreadCount = ref(0)

const isSidebarCollapsed = ref(false)
const toggleSidebar = () => {
  isSidebarCollapsed.value = !isSidebarCollapsed.value
}

const confirm = useConfirm();

const userMenuItems = ref([
  {
    label: 'User Center',
    icon: 'pi pi-user',
    command: () => router.push('/mine'),
  },
  {
    label: 'Settings',
    icon: 'pi pi-cog',
    command: () => router.push('/setting'),
  },
  {
    separator: true
  },
  {
    label: 'Log Out',
    icon: 'pi pi-sign-out',
    command: () => {
      confirm.require({
        message: 'Are you sure you want to log out?',
        header: '',
        icon: null,
        accept: () => {
          localStorage.removeItem('token')
          router.push('/')
        },
        reject: () => {
          // do nothing on cancel
        },
        acceptClass: 'custom-logout-button p-bt-accept',
        rejectClass: 'custom-logout-button p-bt-reject ',
        acceptLabel: 'Log Out',
        rejectLabel: 'Cancel',
      });
    }
  }
])

const mineSubItems = [
      {
        label: 'User Center',
        command: () => router.push('/mine'),

      },{
        label: 'Setting',
        command: () => router.push('/setting'),
      }
    ]
const baseMineItem = {
    label: 'Mine',
    icon: 'pi pi-my',
    command: () => router.push('/mine'),
    customIcon: myIconGray,
    customIconActive: myIcon,
  }
let mineMenuItem = ref({
  ...baseMineItem,
  items: mineSubItems
})

// 检查当前路由，如果在mine或setting页面，则展开子菜单
const currentRoute = router.currentRoute.value.path
if (currentRoute === '/mine' || currentRoute === '/setting') {
  mineMenuItem.value = {
    ...baseMineItem,
    items: mineSubItems
  }
} else {
  mineMenuItem.value = {
    ...baseMineItem
  }
}

function subMenuDisplay(){
  // mineShow  = !mineShow
  if(!mineMenuItem.value.hasOwnProperty('items')){
    // 显示子菜单
    mineMenuItem.value = {
      ...baseMineItem,
      items: mineSubItems
    }
  } else {
    // 隐藏子菜单
    mineMenuItem.value = {
      ...baseMineItem
    }
  }
}

// 监听路由变化，自动展开/收起子菜单
watch(() => router.currentRoute.value.path, (newRoute) => {
  if (newRoute === '/mine' || newRoute === '/setting') {
    // 如果在mine或setting页面，展开子菜单
    mineMenuItem.value = {
      ...baseMineItem,
      items: mineSubItems
    }
  } else {
    // 如果不在mine或setting页面，收起子菜单
    mineMenuItem.value = {
      ...baseMineItem
    }
  }
})

// 计算属性：判断Mine子菜单是否展开
const isMineExpanded = computed(() => {
  return mineMenuItem.value && mineMenuItem.value.items && mineMenuItem.value.items.length > 0
})

function handleCollapsedMineClick() {
  // 在collapsed状态下点击Mine菜单时，直接跳转到mine页面
  router.push('/mine')
}

// 新增：mineSidebarItem 计算属性，自动根据 isSidebarCollapsed 和 mineMenuItem 选择合适的 Mine 菜单项
const mineSidebarItem = computed(() => {
  if (isSidebarCollapsed.value) {
    return {
      ...baseMineItem,
      command: () => router.push('/mine')
    }
  } else {
    return mineMenuItem.value
  }
})

// 优化 sidebarItems 计算属性，直接使用 mineSidebarItem
const sidebarItems = computed(() => [
  {
    label: 'Device',
    icon: 'pi pi-desktop',
    customIcon: deviceIconGray,
    customIconActive: deviceIcon,
    command: () => router.push('/devices'),
  },
  {
    label: 'Workspace',
    icon: 'pi pi-briefcase',
    command: () => router.push('/workspaces'),
    customIcon: workspaceIconGray,
    customIconActive: workspaceIcon
  },
  {
    label: 'Task List',
    icon: 'pi pi-list',
    command: () => router.push('/tasks'),
    customIcon: taskIconGray,
    customIconActive: taskIcon
  },
  {
    label: 'EV charger',
    icon: 'pi pi-bolt',
    command: () => router.push('/charging-stations'),
    customIcon: chargerIconGray,
    customIconActive: chargerIcon
  },
  {
    label: 'Device Message',
    icon: 'pi pi-envelope',
    command: () => router.push('/messages'),
    customIcon: messageIconGray,
    customIconActive: messageIcon
  },
  // {
  //   label: 'Map Test',
  //   icon: 'pi pi-map',
  //   command: () => router.push('/map-test'),
  // },
  mineSidebarItem.value
])

const showNotification = ref(false)
function onBellClick() {
  showNotification.value = !showNotification.value
}

const getCustomIcon = (item) => {
  if (item.customIcon) {
    const currentRoute = router.currentRoute.value.path
    let isActive = false
    switch (item.label) {
      case 'Device':
        isActive = currentRoute === '/devices'
        break
      case 'Workspace':
        isActive = currentRoute === '/workspaces'
        break
      case 'Task List':
        isActive = currentRoute === '/tasks'
        break
      case 'EV charger':
        isActive = currentRoute === '/charging-stations'
        break
      case 'Device Message':
        isActive = currentRoute === '/messages'
        break
      case 'Map Test':
        isActive = currentRoute === '/map-test'
        break
      case 'Mine':
        isActive = currentRoute === '/mine' || currentRoute === '/setting'
        break
      case 'Setting':
        isActive = currentRoute === '/setting'
        break
    }
    if (isActive && item.customIconActive) {
      return item.customIconActive
    }
    return item.customIcon
  }
  return null
}

const isMenuItemActive = (item) => {
  const currentRoute = router.currentRoute.value.path
  let isActive = false
  switch (item.label) {
    case 'Device':
      isActive = (route.meta.activeMenu === '/devices') ||currentRoute === '/devices'
      break
    case 'Workspace':
      isActive = (route.meta.activeMenu === '/workspaces') || currentRoute === '/workspaces'
      break
    case 'Task List':
      isActive = currentRoute === '/tasks'
      break
    case 'EV charger':
      isActive = currentRoute === '/charging-stations'
      break
    case 'Device Message':
      isActive = currentRoute === '/messages'
      break
    case 'Map Test':
      isActive = currentRoute === '/map-test'
      break
    case 'Mine':
      isActive = currentRoute === '/mine' || currentRoute === '/setting'
      break
    case 'User Center':
      isActive = currentRoute === '/mine'
      break
    case 'Setting':
      isActive = currentRoute === '/setting'
      break
  }
  return isActive
}

// 生成面包屑数组
const breadcrumbs = computed(() => {
  const bc = [];
  if (route.meta && route.meta.parentBreadcrumb) {
    bc.push({ label: route.meta.parentBreadcrumb, path: '' });
  }
  if (route.meta && route.meta.breadcrumb) {
    bc.push({ label: route.meta.breadcrumb, path: route.path });
  }
  return bc;
});

let ws = null
let ws_count = 0;

function createWebSocket() {
  console.log('ws_count:', ws_count)
  const token = localStorage.getItem('token')
  if (!token) return
  const protocols = [token]
  try {
    ws = new window.WebSocket(`${WS_BASE_URL}/ws/user`, protocols)
    ws.onopen = () => {
      console.log('WebSocket connected')
    }
    ws.onclose = () => {
      console.log('WebSocket closed')
    }
    ws.onerror = (e) => {
      console.error('WebSocket error', e)
    }
    ws.onmessage = (msg) => {
      console.log('WebSocket message', msg.data)
      try {
        const data = JSON.parse(msg.data)
        if (data.t === 'newMsgRequest' && data.body) {
          unreadCount.value = data.body.amount
        }
      } catch (err) {
        console.error('Failed to parse ws message: ', err)
      }
    }
    window._ws = ws
  } catch (err) {
    console.error('WebSocket connection failed:', err)
    ws = null
  }
}

onMounted(() => {
  createWebSocket()
})

onUnmounted(() => {
  if (ws) {
    ws.close()
    ws = null
  }
})
</script>

<style scoped>
.layout-wrapper {
  display: flex;
  min-height: 100vh;
  background: #232323;
  width: 100vw;
}

.layout-sidebar {
  width: 230px;
  background: #FFFFFF;
  border-radius: 0;
  box-shadow: 1px 0 4px 0 rgba(0,0,0,0.03);
  border: none;
  border-right: solid 1px #EBEBEB;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  transition: width 0.2s;
}

.layout-sidebar.collapsed {
  width: 80px;
}

.sidebar-logo {
  display: flex;
  align-items: center;
  padding: 24px 32px;
  justify-content: flex-start;
  transition: all 0.2s;
}

.layout-sidebar.collapsed .sidebar-logo {
  padding: 24px 0;
  justify-content: center;
}

.logo-img {
  height: 32px;
  margin-right: 8px;
}

.logo-img-collapsed {
  height: 32px;
  width: 32px;
}

/* Menu Styles - Optimized without excessive !important */
:deep(.p-menu) {
  border: none;
  --p-menu-item-focus-background: transparent;
}

:deep(.p-menu-item) {
  padding: 6px 14px;
}

:deep(.p-menu-submenu-label) {
  padding: 6px 14px;
}

:deep(.p-menu .p-menu-submenu-label .p-menuitem-link.active-menu-item) {
  background: none;
}

:deep(.p-menu .p-menuitem-link) {
  color: #222;
  font-size: 15px;
  padding: 6px 16px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: padding 0.2s;
  height: 44px;
}

:deep(.p-menu .p-menuitem-link:hover) {
  background: #F9F9F9;
}

:deep(.p-menu .p-menuitem.p-focus .p-menuitem-link) {
  background: #e6f0ff;
}

:deep(.p-menu .p-menuitem.p-focus .p-menuitem-link .p-menuitem-text) {
  color: #7DA500;
}

:deep(.p-menu .p-menuitem-link.active-menu-item) {
  background: #F9F9F9;
}

:deep(.p-menu .p-menuitem-link.active-menu-item .p-menuitem-text) {
  color: #7DA500;
}

:deep(.p-menu .p-menuitem-icon) {
  margin-right: 16px;
  font-size: 18px;
}

:deep(.p-menu .p-menuitem-link .custom-icon) {
  width: 24px;
  height: 24px;
  transition: all 0.2s;
}

:deep(.p-menu .p-menuitem-text) {
  transition: opacity 0.2s, width 0.2s;
  white-space: nowrap;
  flex: 1;
}

:deep(.p-menu .p-submenu-icon) {
  margin-left: auto;
  font-size: 12px;
  color: #666;
  transition: transform 0.2s;
}

:deep(.p-menu .p-menuitem.p-highlight .p-submenu-icon) {
  transform: rotate(180deg);
}

/* Collapsed state styles */
.layout-sidebar.collapsed :deep(.p-menu .p-menuitem-text) {
  display: none;
}

.layout-sidebar.collapsed :deep(.p-menu .p-submenu-icon) {
  display: none;
}

.layout-sidebar.collapsed :deep(.p-menu .p-menuitem-link) {
  padding-left: 24px;
  padding-right: 24px;
  justify-content: center;
}

.layout-sidebar.collapsed :deep(.p-menu .p-menuitem-icon) {
  margin-right: 0;
}

.layout-sidebar.collapsed :deep(.p-menu .p-menuitem) {
  width: 100%;
  min-width: unset;
}

.layout-sidebar.collapsed :deep(.p-menu) {
  width: 100%;
  min-width: unset;
}

/* Hide submenus in collapsed state */
.layout-sidebar.collapsed :deep(.p-menu .p-submenu-list) {
  display: none;
}

.layout-sidebar.collapsed :deep(.p-menu .p-menuitem.p-submenu) {
  display: none;
}

/* Cursor pointer for collapsed state */
.layout-sidebar.collapsed :deep(.p-menu .p-menuitem-link) {
  cursor: pointer;
}

.layout-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0;
  min-height: 100vh;
  overflow-x: auto;
}

.layout-menubar {
  height: 56px;
  background: #fff;
  border-radius: 0;
  margin-bottom: 0;
  box-shadow: 0 1px 4px 0 rgba(0,0,0,0.03);
  padding: 0 22px 0 20px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ececec;
  position: relative;
}

.sidebar-toggle-btn {
  width: 24px;
  height: 24px;
  cursor: pointer;
  margin-right: 16px;
}

.menubar-breadcrumb {
  font-size: 15px;
  color: #888;
  font-weight: 500;
  display: inline-block;
}

.menubar-actions {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-left: auto;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 13px;
  cursor: pointer;
  min-width: 10.625rem;
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 4px;
}

.user-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 40px;
  justify-content: center;
}

.user-name {
  font-size: 14px;
  color: #222;
  font-weight: 600;
  line-height: 1.2;
}

.user-email {
  font-size: 12px;
  color: #888;
  line-height: 1.2;
  min-height: 14px;
}

.layout-content {
  flex: 1;
  padding: 20px;
  background: #F9F9F9;
  border-radius: 0;
  box-shadow: none;
  min-height: 600px;
  display: flex;
  flex-direction: column;
}

/* 确保在小屏幕上布局内容仍然可用 */
@media (max-height: 700px) {
  .layout-content {
    min-height: 400px;
  }
}

.bell-wrapper {
  position: relative;
  display: inline-block;
}

.dot-red {
  position: absolute;
  top: -4px;
  right: -4px;
  width: 10px;
  height: 10px;
  background: #E51800;
  border-radius: 50%;
  border: 2px solid #fff;
  z-index: 2;
  display: block;
}

.breadcrumb-last {
  color: #333333;
}
</style>

<style>
.p-menu {
  border: none;
}

.layout-menu {
  border: none;
  border-radius: 0;
  background: transparent;
  margin-top: 8px;
  transition: padding 0.2s;
  min-width: unset;
}

:deep(.p-menu .p-submenu-list .p-menuitem-link) {
  padding-left: 48px;
}

:deep(.p-menu .p-submenu-list .p-menuitem-link.active-menu-item) {
  background: #F9F9F9;
}

:deep(.p-menu .p-submenu-list .p-menuitem-link.active-menu-item .p-menuitem-text) {
  color: #7DA500;
}

/* User Dropdown Menu Styles */
.user-dropdown-menu.p-menu {
  min-width: 146px !important;
  margin-top: 16px !important;
  border-radius: 8px;
  border: none;
  box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.16);
  padding: 6px;
  background: #FFFFFF;
}

.user-dropdown-menu .p-menuitem {
  padding: 0;
  margin: 0;
}

.user-dropdown-menu .p-menuitem-content {
  background: transparent;
  border-radius: 4px;
  margin: 2px;
}

.user-dropdown-menu .p-menuitem-link {
  font-size: 14px;
  color: #222;
  padding: 10px 16px;
  gap: 12px;
  display: flex;
  align-items: center;
  border-radius: 4px;
}

.user-dropdown-menu .p-menuitem:not(.p-disabled) > .p-menuitem-content:hover {
  background: #F9F9F9;
  color: #222;
}

.user-dropdown-menu .p-menuitem-link .p-menuitem-icon {
  font-size: 16px;
  color: #555;
  margin-right: 0px;
}

.user-dropdown-menu .p-menu-separator {
  margin: 6px 0;
  padding: 0;
  border-top: 1px solid #EBEBEB;
}

.p-confirm-dialog {
  width: 318px !important;
  height: 144px !important;
}

.p-confirmdialog.p-dialog {
  border-radius: 8px;
  overflow: hidden;
}

.p-confirmdialog .p-dialog-content {
  padding: 32px 24px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  border-radius: 0;
}

.p-confirmdialog .p-confirmdialog-message {
  margin: 0;
  font-size: 18px;
  color: #333333;
  text-align: center;
  font-weight: 600;
}

.p-confirmdialog .p-dialog-footer {
  padding: 0 24px 24px 24px;
  display: flex;
  justify-content: center;
  gap: 16px;
}
.custom-logout-button
{
  width: 128px;
}
.p-confirmdialog .p-confirmdialog-reject-button {
  min-width: 80px;
  color: #666666 !important;
  background: transparent !important;
  border: 1px solid #EBEBEB;
}

.p-confirmdialog .p-confirmdialog-reject-button:hover {
  background: #F9F9F9 !important;
  border-color: #EBEBEB !important;
}

.p-confirmdialog .p-confirmdialog-accept-button.custom-logout-button {
  min-width: 80px;
  background: #9E1000 !important;
  border: none !important;
}

.p-confirmdialog .p-dialog-header {
  display: none;
}

.p-confirmdialog .p-dialog-header-close {
  display: none !important;
}

.p-confirmdialog .p-dialog-header-icons {
  display: none !important;
}
</style>